/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   09/08/2022
 */

import React from "react";
import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";
import SlackUserChannelSelectorControl from "../../controls/SlackUserChannelSelectorControl";
import {SlackConversation} from "../../interfaces/Global";

export interface ConfigDeliveryProps {
	deliverTo: string
	setDeliverTo: (to: string) => void
	slackChannel?: SlackConversation
	setSlackChannel: (channel: SlackConversation|null) => void
	slackChannelError?: string
	disabled?: boolean
}

export default function ConfigDelivery({ deliverTo, setDeliverTo, slackChannel, disabled, setSlackChannel, slackChannelError }: ConfigDeliveryProps) {


	return (
		<FormControl sx={{ mb: 2 }}>
			<RadioGroup
				value={deliverTo}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
					const value = (event.target as HTMLInputElement).value;
					setDeliverTo(value);
					setSlackChannel(slackChannel ?? null);
				}}
			>
				<FormControlLabel value="self" control={<Radio disabled={disabled} />} label="Send to me" />
				<FormControlLabel value="channel" control={<Radio disabled={disabled} />} label="Send to channel" />
			</RadioGroup>
			{deliverTo === "channel" &&
			<SlackUserChannelSelectorControl
				channel={slackChannel}
				error={slackChannelError}
				disabled={disabled}
				redirectUri={process.env.NODE_ENV === "development" ? "https://jwt.io" :
					window.location.origin + window.location.pathname}
				onChange={setSlackChannel}
			/>}
		</FormControl>
	);

}